import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drivingDifficultyWetIcon",
  "use": "icon-drivingDifficultyWetIcon-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-drivingDifficultyWetIcon\"><path d=\"M6.086 11.578a1.533 1.533 0 0 1-3.066 0C3.02 10.475 4.553 8 4.553 8s1.533 2.475 1.533 3.578ZM7.95 4.644a1.133 1.133 0 0 1-2.266 0C5.684 3.83 6.817 2 6.817 2S7.95 3.83 7.95 4.644ZM14.352 11a3 3 0 0 1-6 0c0-2.157 3-7 3-7s3 4.843 3 7Z\" stroke=\"#4C556C\" stroke-width=\"1.333\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol